import React from "react";
import { formatToYYYYMMDD } from "@/lib/dateUtils";

const PublicPrintButton = ({ selectedDate }) => {
  const handlePrint = () => {
    const dateStr = formatToYYYYMMDD(selectedDate);

    // ✅ Абсолютний шлях, без прив'язки до поточного маршруту
    const absoluteUrl = `${window.location.origin}/print-schedule?date=${dateStr}`;

    const printWindow = window.open(absoluteUrl, "_blank");
    if (printWindow) {
      printWindow.focus();
    } else {
      alert("Не вдалося відкрити вікно друку. Перевірте блокування спливаючих вікон.");
    }
  };

  return (
    <button
      onClick={handlePrint}
      className="bg-primary text-white text-sm px-3 py-1 rounded hover:opacity-90"
    >
      🖨️ Друк
    </button>
  );
};

export default PublicPrintButton;
